import axios from '@/libs/api.request.js'

export default {
    // 登录
    login: (data) => {
        return axios.request({
            url: 'login',
            data,
            method: 'post'
        })
    },
    // 注册
    register: (data) => {
        return axios.request({
            url: 'register',
            data,
            method: 'post'
        })
    },
    // 发送验证码
    getCaptcha: (params) => {
        return axios.request({
            url: 'captcha',
            params,
            method: 'get'
        })
    },
    // 获取商户应用信息
    getAppList: () => {
        return axios.request({
            url: 'app/listApp',
            method: 'get'
        })
    },
    // 获取应用登录token
    getAppToken: (params) => {
        return axios.request({
            url: 'app/getAppToken',
            params,
            method: 'get'
        })
    },
    // 新手引导状态
    checkGuideStatus: () => {
        return axios.request({
            url: 'user/isNoviceGuide',
            method: 'get'
        })
    },
    // 设置新手引导状态
    setGuideStatus: () => {
        return axios.request({
            url: 'user/setNoviceGuide',
            method: 'get'
        })
    },
    // 个人信息修改
    updateInfo: (params) => {
        return axios.request({
            url: 'user/update/info',
            params,
            method: 'get'
        })
    },
    // 个人信息
    getInfo: () => {
        return axios.request({
            url: 'user/info',
            method: 'get'
        })
    }
}